import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { Rubric } from '@mira-avant/mtlibs';
import { CommonModule } from '@angular/common';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { RouterModule } from '@angular/router';
import { RubricService } from '../../../../services/rubric.service';
import { ZorroModule } from '../../../../modules/zorro.module';

@Component({
	selector: 'app-rubrics-table',
	standalone: true,
	imports: [
		CommonModule,
		NzTableModule,
		NzButtonModule,
		NzTypographyModule,
		RouterModule,
		ZorroModule,
	],
	templateUrl: './rubrics-table.component.html',
	styleUrl: './rubrics-table.component.scss',
})
export class RubricsTableComponent implements OnInit, OnDestroy {
	@Input('mode') public mode: 'select' | 'edit' = 'edit';
	public rubrics: Rubric[] = [];
	private subscriptions: Subscription = new Subscription();

	constructor(public rubricService: RubricService) {}

	ngOnInit(): void {
		// Subscribe to rubrics
		this.subscriptions.add(
			this.rubricService.rubrics$.subscribe(rubrics => {
				this.rubrics = rubrics;
			})
		);

		// Fetch rubrics
		this.rubricService.getRubrics$().catch(error => {
			console.error('Error fetching rubrics:', error);
			this.rubrics = [];
		});
	}

	public async deleteRubric(code: string): Promise<void> {
		try {
			await this.rubricService.deleteRubric$(code);
		} catch (error) {
			console.error('Error deleting rubric:', error);
		}
	}

	public selectRubric(rubric: Rubric | undefined): void {
		this.rubricService.selectRubric(rubric);
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}
}
